// Official WhatsApp brand icon as an inline SVG
const WhatsAppIcon = ({ size = 28, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.65-.515 2.95-1.318.144-.4.144-.74.073-1.137-.1-.5-1.973-1.357-2.41-1.557zM16.077 6.85c-5.495 0-9.962 4.466-9.962 9.962a9.94 9.94 0 0 0 1.792 5.696L6.117 26.18l3.81-1.21a9.97 9.97 0 0 0 6.15 2.094c5.5 0 9.967-4.466 9.967-9.962 0-2.667-1.04-5.166-2.92-7.046a9.86 9.86 0 0 0-7.046-2.93zm5.945 15.913a8.18 8.18 0 0 1-5.776 2.396c-1.806 0-3.563-.602-5-1.71l-.36-.214-2.122.68.68-2.094-.246-.36c-1.214-1.504-1.86-3.275-1.86-5.116 0-4.667 3.812-8.467 8.482-8.467 2.265 0 4.394.875 6 2.47a8.39 8.39 0 0 1 2.487 5.993 8.18 8.18 0 0 1-2.487 5.99z"
    />
  </svg>
);

export default WhatsAppIcon;
